import httpService from "./httpService";

const DownloadImageApi = {
  
  getDownloadedImageul: (id) => httpService.get(`getMediaSignedUrl/?media_id=${id||""}`),
   
};

export default DownloadImageApi;
